import { typeUser } from "../../../../pages/questionnaire/pages/detail/methods/actionPlan/contants"

const evidenceTemplate = {
    "image": {
        "active": true,
        "required": false,
        "png": true,
        "jpg": true,
        "jpeg": true,
        "maxSize": {
            "label": "20 Mb",
            "value": 20,
            "id": "20"
        },
        "maxAmount": "5",
        "minAmount": 1
    },
    "camera": {
        "active": true,
        "required": false,
        "png": true,
        "jpg": true,
        "jpeg": true,
        "maxSize": {
            "label": "20 Mb",
            "value": 20,
            "id": "20"
        },
        "maxAmount": "5",
        "minAmount": 1
    },
    "video": {
        "active": true,
        "required": false,
        "maxSize": {
            "label": "40 Mb",
            "value": 40,
            "id": "40"
        },
        "maxAmount": 1,
        "minAmount": 1
    },
    "video_gallery": {
        "active": true,
        "required": false,
        "mp4": true,
        "wmv": true,
        "wma": true,
        "maxSize": {
            "label": "40 Mb",
            "value": 40,
            "id": "40"
        },
        "maxAmount": 1,
        "minAmount": 1
    },
    "sign": {
        "active": true,
        "required": false,
        "maxAmount": 1,
        "minAmount": 1
    },
    "comment": {
        "active": true,
        "required": false,
        "maxCharacters": 255,
        "maxAmount": 1,
        "minAmount": 1
    },
    "file": {
        "active": true,
        "required": false,
        "pdf": true,
        "csv": true,
        "docx": true,
        "xlsx": true,
        "pptx": true,
        "txt": true,
        "maxSize": {
            "label": "5 Mb",
            "value": 5,
            "id": "5"
        },
        "maxAmount": 1,
        "minAmount": 1
    }
}

const basicTemplate = {
    "image": {
        "active": true,
        "required": true,
        "png": true,
        "jpg": true,
        "jpeg": true,
        "maxSize": {
            "label": "1 Mb",
            "value": 1,
            "id": "1"
        },
        "maxAmount": "1",
        "minAmount": "1"
    },
    "camera": {
        "active": true,
        "required": true,
        "png": true,
        "jpg": true,
        "jpeg": true,
        "maxSize": {
            "label": "1 Mb",
            "value": 1,
            "id": "1"
        },
        "maxAmount": "1",
        "minAmount": "1"
    },
    "video": {
        "active": true,
        "required": true,
        "maxSize": {
            "label": "10 Mb",
            "value": 10,
            "id": "10"
        },
        "maxAmount": "1",
        "minAmount": "1"
    },
    "video_gallery": {
        "active": true,
        "required": true,
        "mp4": true,
        "wmv": true,
        "wma": true,
        "maxSize": {
            "label": "10 Mb",
            "value": 10,
            "id": "10"
        },
        "maxAmount": "1",
        "minAmount": "1"
    },
    "sign": {
        "active": true,
        "required": true,
        "maxAmount": "1",
        "minAmount": "1"
    },
    "comment": {
        "active": true,
        "required": true,
        "maxCharacters": "255",
        "maxAmount": "1",
        "minAmount": "1"
    },
    "file": {
        "active": true,
        "required": false,
        "pdf": true,
        "csv": true,
        "docx": true,
        "xlsx": true,
        "pptx": true,
        "txt": true,
        "maxSize": {
            "label": "1 Mb",
            "value": 1,
            "id": "1"
        },
        "maxAmount": "1",
        "minAmount": "1"
    }
}
const expandTemplate = {
    "image": true,
    "camera": true,
    "video": true,
    "video_gallery": true,
    "sign": true,
    "comment": true,
    "file": true
}

const folioManagementDefault = {
    required: false,
    maxCharacters: '255',
    type: typeUser.APPROVER,
    active: true
}
export { evidenceTemplate, expandTemplate, basicTemplate, folioManagementDefault }